import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAnnonces } from "../context/AnnoncesContext";
import MapAlgerie from "../components/MapAlgerie";

const catalogueDataLeft = [
  { id: 1, title: "LE YACHTING", catId: "yachting", items: [
    { label: "Yachts de luxe",   slug: "yachts-luxe" },
    { label: "Yacht toys",       slug: "yacht-toys"  },
  ]},
  { id: 3, title: "LES BATEAUX A MOTEUR", catId: "moteur", items: [
    { label: "Bateaux à moteur avec cabine",        slug: "moteur-cabine"    },
    { label: "Bateaux à moteur open",               slug: "moteur-open"      },
    { label: "Bateaux pneumatiques",                slug: "pneumatiques"     },
    { label: "Bateaux offshore, jet-skis",          slug: "offshore-jetski"  },
    { label: "Bateaux électriques et hybrides",     slug: "electrique"       },
  ]},
  { id: 5, title: "LA VOILE", catId: "voile", items: [
    { label: "Voiliers monocoques",                  slug: "monocoque"       },
    { label: "Voiliers multicoques",                 slug: "multicoque"      },
    { label: "Voile légère",                         slug: "voile-legere"    },
    { label: "Équipements, vêtements de voile",      slug: "equipement-voile"},
  ]},
  { id: 7, title: "L'ÉQUIPEMENT", catId: "equipement", items: [
    { label: "Gréements, accastillage",               slug: "greement"        },
    { label: "Électronique marine",                   slug: "electronique"    },
    { label: "Moteurs hors-bord et in-bord",          slug: "moteurs"         },
    { label: "Propulsion, commandes moteur",          slug: "propulsion"      },
    { label: "Équipements de pont, entretien",        slug: "pont"            },
    { label: "Sécurité",                              slug: "securite"        },
    { label: "Vêtements et équipements de la personne", slug: "vetements"     },
    { label: "Confort à bord",                        slug: "confort"         },
    { label: "Eau, électricité",                      slug: "eau-electricite" },
  ]},
  { id: 9, title: "LES SPORTS ET LOISIRS", catId: "sports", items: [
    { label: "Kayaks, avirons, canoës",               slug: "kayak"           },
    { label: "Plongée sous-marine",                   slug: "plongee"         },
    { label: "Chasse sous-marine",                    slug: "chasse-marine"   },
    { label: "Pêche",                                 slug: "peche"           },
    { label: "Sports de glisse",                      slug: "glisse"          },
    { label: "Bases de loisirs",                      slug: "loisirs"         },
  ]},
];

const catalogueDataRight = [
  { id: 2, title: "LES MARINAS", catId: "marinas", items: [
    { label: "Manutention des bateaux",               slug: "manutention"     },
    { label: "Aménagement des marinas",               slug: "amenagement"     },
    { label: "Maisons flottantes, bateaux maisons",   slug: "flottant"        },
  ]},
  { id: 4, title: "NAVIRES ET BATEAUX PROFESSIONNELS", catId: "navires", items: [
    { label: "Navires de transport marchandises et passagers", slug: "transport" },
    { label: "Navires de services et spéciaux",       slug: "services"        },
    { label: "Bateaux de services et de travail",     slug: "travail"         },
    { label: "Bateaux d'activités touristiques",      slug: "tourisme"        },
  ]},
  { id: 6, title: "ÉQUIPEMENTS MARITIMES", catId: "equipement", items: [
    { label: "Motorisation conventionnelle",          slug: "motorisation"    },
    { label: "Motorisation alternatives",             slug: "motorisation-alt"},
    { label: "Navigation, communication, électronique",slug: "nav-com"        },
    { label: "Équipements de pont, marchandises",     slug: "pont-marchand"   },
    { label: "Eau, déchets, émissions",               slug: "environnement"   },
  ]},
  { id: 8, title: "PORTS ET TERMINAUX", catId: "marinas", items: [
    { label: "Manutention des marchandises",          slug: "marchandises"    },
    { label: "Bateaux de travail portuaire",          slug: "portuaire"       },
    { label: "Sécurité portuaire, anti-pollution",    slug: "securite-port"   },
    { label: "Équipements portuaires",                slug: "equipement-port" },
  ]},
  { id: 10, title: "LA CONSTRUCTION NAVALE", catId: "construction", items: [
    { label: "Matériaux et peintures",                slug: "materiaux"       },
    { label: "Machines de production et outillage",   slug: "outillage"       },
  ]},
];

function AccordionItem({ category, isOpen, onToggle }) {
  return (
    <div style={{ backgroundColor: "white", borderRadius: "4px", overflow: "hidden", boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}>
      <div style={{ display: "flex", alignItems: "center", borderLeft: "3px solid #0d9488" }}>
        <Link
          to={`/catalogue?categorie=${category.catId}`}
          style={{ flex: 1, display: "flex", alignItems: "center", padding: "16px 20px", textDecoration: "none", backgroundColor: "white" }}
        >
          <span style={{ fontSize: "14px", fontWeight: "500", color: "#0d9488", letterSpacing: "0.3px" }}>
            {category.title}
          </span>
        </Link>
        <button onClick={onToggle} style={{ padding: "16px 16px", border: "none", backgroundColor: "white", cursor: "pointer" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2"
            style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s ease", display: "block" }}>
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>
      </div>
      {isOpen && (
        <div style={{ padding: "0 20px 18px 26px", borderLeft: "3px solid #0d9488" }}>
          {category.items.map((item, index) => (
            <Link
              key={index}
              to={`/catalogue?categorie=${category.catId}&sous_categorie=${item.slug}`}
              style={{ display: "block", padding: "8px 0", color: "#6b7280", textDecoration: "none", fontSize: "13px", textTransform: "uppercase", letterSpacing: "0.3px" }}
              onMouseEnter={e => e.target.style.color = "#0d9488"}
              onMouseLeave={e => e.target.style.color = "#6b7280"}
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

function Accueil() {
  const { annonces } = useAnnonces();
  const newProducts = annonces.slice(0, 3);
  const [openLeft, setOpenLeft] = useState(null);
  const [openRight, setOpenRight] = useState(null);

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />

      <section className="hero-section" style={{ position: "relative", height: "550px", backgroundImage: "url('https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=1920')", backgroundSize: "cover", backgroundPosition: "center", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(255,255,255,0.4)" }}></div>
        <div style={{ position: "relative", textAlign: "center", maxWidth: "800px", padding: "0 20px" }}>
          <p style={{ color: "#0d9488", fontSize: "14px", fontWeight: "600", marginBottom: "20px", letterSpacing: "1px" }}>La premiere plateforme maritime en Algerie</p>
          <h1 className="hero-title" style={{ fontSize: "48px", fontWeight: "700", color: "#1f2937", marginBottom: "20px", lineHeight: "1.2" }}>
            Decouvrez le monde maritime avec <span style={{ color: "#0d9488" }}>MarinaDZ</span>
          </h1>
          <p className="hero-subtitle" style={{ fontSize: "18px", color: "#2e3640", marginBottom: "35px", lineHeight: "1.6" }}>
            Explorez notre catalogue de bateaux, yachts, equipements et services maritimes.
          </p>
          <div className="hero-btns" style={{ display: "flex", gap: "15px", justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/catalogue" style={{ display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "#0d9488", color: "white", padding: "14px 28px", borderRadius: "8px", textDecoration: "none", fontSize: "15px", fontWeight: "600" }}>
              Explorer le catalogue
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </Link>
            <Link to="/inscription" style={{ display: "inline-flex", alignItems: "center", backgroundColor: "white", color: "#1f2937", padding: "14px 28px", borderRadius: "8px", textDecoration: "none", fontSize: "15px", fontWeight: "600", border: "1px solid #d1d5db" }}>
              Devenir Exposant
            </Link>
          </div>
        </div>
      </section>

      <section className="section-padded" style={{ backgroundColor: "#f5f5f5" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "28px", fontWeight: "700", color: "#1f2937", marginBottom: "10px", textAlign: "center" }}>Notre Catalogue</h2>
          <p style={{ fontSize: "16px", color: "#6b7280", marginBottom: "40px", textAlign: "center" }}>Explorez toutes nos categories de produits et services maritimes</p>
          <div className="grid-responsive accueil-catalogue-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              {catalogueDataLeft.map(category => (
                <AccordionItem key={category.id} category={category}
                  isOpen={openLeft === category.id}
                  onToggle={() => setOpenLeft(prev => prev === category.id ? null : category.id)} />
              ))}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              {catalogueDataRight.map(category => (
                <AccordionItem key={category.id} category={category}
                  isOpen={openRight === category.id}
                  onToggle={() => setOpenRight(prev => prev === category.id ? null : category.id)} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section-padded" style={{ backgroundColor: "white" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "28px", fontWeight: "700", color: "#1f2937", marginBottom: "10px" }}>Dernieres Annonces</h2>
          <p style={{ fontSize: "16px", color: "#6b7280", marginBottom: "40px" }}>Decouvrez nos dernieres annonces selectionnees</p>
          <div className="accueil-annonces-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "25px" }}>
            {newProducts.map(product => (
              <Link to={`/annonce/${product.id}`} key={product.id}
                style={{ textDecoration: "none", backgroundColor: "white", borderRadius: "12px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", border: "1px solid #e5e7eb" }}>
                <div style={{ position: "relative" }}>
                  <img src={product.image || "/placeholder.svg"} alt={product.nom} style={{ width: "100%", height: "220px", objectFit: "cover" }} />
                  {product.isNew && (
                    <span style={{ position: "absolute", top: "12px", left: "12px", backgroundColor: "#0d9488", color: "white", padding: "5px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: "600" }}>Nouveau</span>
                  )}
                </div>
                <div style={{ padding: "20px" }}>
                  <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937", marginBottom: "8px" }}>{product.nom}</h3>
                  <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "12px" }}>{product.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padded" style={{ backgroundColor: "#0d9488", textAlign: "center" }}>
        <div style={{ maxWidth: "700px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "28px", fontWeight: "700", color: "white", marginBottom: "15px" }}>Vous etes un professionnel du secteur maritime ?</h2>
          <p style={{ fontSize: "16px", color: "rgba(255,255,255,0.9)", marginBottom: "35px", lineHeight: "1.6" }}>Rejoignez MarinaDZ et exposez vos produits a des milliers de passionnes de la mer en Algerie.</p>
          <Link to="/inscription" style={{ display: "inline-flex", alignItems: "center", gap: "10px", backgroundColor: "white", color: "#1f2937", padding: "14px 30px", borderRadius: "8px", textDecoration: "none", fontSize: "15px", fontWeight: "600" }}>
            Devenir Exposant
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </Link>
        </div>
      </section>

      <section className="section-padded" style={{ backgroundColor: "#f9fafb" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "32px" }}>
            <h2 style={{ fontSize: "28px", fontWeight: "700", color: "#1f2937", marginBottom: "10px" }}>Trouvez des annonces près de chez vous</h2>
            <p style={{ fontSize: "16px", color: "#6b7280" }}>Cliquez sur une wilaya pour découvrir les annonces disponibles</p>
          </div>
          <MapAlgerie />
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Accueil;